/**
 * Note Node Component
 */
import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { StickyNote } from 'lucide-react';
import styles from './Nodes.module.css';

export const NoteNode: React.FC<NodeProps> = memo(({ data, selected }) => {
  return (
    <div className={`${styles.node} ${styles.noteNode} ${selected ? styles.selected : ''}`}>
      <div className={styles.nodeContent}>
        <div className={styles.nodeIcon} style={{ backgroundColor: '#fbbf24' }}>
          <StickyNote size={16} color="white" />
        </div>
        <div className={styles.nodeDetails}>
          <span className={styles.nodeLabel}>{data.label || 'Note'}</span>
          {data.text && (
            <span className={styles.nodeSubtitle}>{data.text}</span>
          )}
        </div>
      </div>
    </div>
  );
});

NoteNode.displayName = 'NoteNode';
